webpackJsonp([226831201382944],{

/***/ 420:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTQgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT50aWNrPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9InRpY2siIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuNzE3NTE0LCA0LjcxNzUxNCkgcm90YXRlKDQ1LjAwMDAwMCkgdHJhbnNsYXRlKC02LjcxNzUxNCwgLTQuNzE3NTE0KSB0cmFuc2xhdGUoMy4yMTc1MTQsIC0xLjI4MjQ4NikiIGZpbGw9IiM1REUyRjkiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSItOC44ODE3ODQyZS0xNiIgeT0iOSIgd2lkdGg9IjQiIGhlaWdodD0iMyI+PC9yZWN0PgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLUNvcHkiIHg9IjMuNTg1Nzg2NDQiIHk9Ii0xLjc3NjM1Njg0ZS0xNSIgd2lkdGg9IjMiIGhlaWdodD0iMTIiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _radium = __webpack_require__(23);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _singleFormLayout = __webpack_require__(248);
	
	var _singleFormLayout2 = _interopRequireDefault(_singleFormLayout);
	
	var _formsShared = __webpack_require__(91);
	
	var _palette = __webpack_require__(17);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _tick = __webpack_require__(420);
	
	var _tick2 = _interopRequireDefault(_tick);
	
	var _reactHelmet = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var STYLES = _extends({
	  title: {
	    fontSize: 30,
	    width: '100%',
	    marginBottom: 20
	  },
	  link: {
	    color: '#43C4D1',
	    textDecoration: 'none'
	  },
	  hr: {
	    paddingTop: '5px',
	    paddingBottom: '5px'
	  },
	  ul: {
	    listStyle: 'none',
	    marginLeft: 0,
	    paddingLeft: '1em',
	    textIndent: '-1em',
	    lineHeight: 2,
	    textAlign: 'left'
	  },
	  li: {
	    paddingLeft: '10px'
	  }
	}, _formsShared.FORM_STYLES);
	
	var WindowsLinux = function (_Component) {
	  _inherits(WindowsLinux, _Component);
	
	  function WindowsLinux() {
	    _classCallCheck(this, WindowsLinux);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  WindowsLinux.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Windows & Linux | Haiku'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'During Designer Preview, Haiku is available on macOS. Join the waitlist to be the first to know about Haiku for Windows or Linux.' }),
	        _react2.default.createElement('meta', { property: 'og:title', content: 'Windows & Linux | Haiku' }),
	        _react2.default.createElement('meta', { property: 'og:description', content: 'During Designer Preview, Haiku is available on macOS. Join the waitlist to be the first to know about Haiku for Windows or Linux.' })
	      ),
	      _react2.default.createElement(
	        _singleFormLayout2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: STYLES.formWrap },
	          _react2.default.createElement(
	            'h2',
	            { style: STYLES.title },
	            'Haiku for Windows & Linux'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: STYLES.label },
	            'During Designer Preview, Haiku is available on macOS.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: STYLES.label },
	            'Join the waitlist to be the first to know about Haiku for Windows or Linux.'
	          ),
	          _react2.default.createElement(
	            'a',
	            { style: _formsShared.FORM_STYLES.btnLink, href: 'https://goo.gl/forms/TW85npTUF7ofmAq02', target: '_blank' },
	            'JOIN THE WAITLIST'
	          ),
	          _react2.default.createElement(
	            'a',
	            { style: STYLES.link, href: ("https://account.haiku.ai") + '/new' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Back to Haiku for Mac'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return WindowsLinux;
	}(_react.Component);
	
	exports.default = (0, _radium2.default)(WindowsLinux);
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-windows-and-linux-js-f8a308a4b3d8eca15433.js